import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-info-rental',
  templateUrl: './base-info-rental.component.html',
  styleUrls: ['./base-info-rental.component.css']
})
export class BaseInfoRentalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
